import { useState } from "react";
import { services } from "@/mocks/services";

export default function ServicesTabs() {
  const [active, setActive] = useState(0);
  const svc = services[active];

  return (
    <>
      <section className="py-16 max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="flex flex-wrap gap-2 mb-12 p-1 bg-[#0f0f0f] rounded-sm border border-white/5 w-fit">
          {services.map((s, i) => (
            <button
              key={s.id}
              onClick={() => setActive(i)}
              className={`whitespace-nowrap flex items-center gap-2 px-5 py-3 text-sm font-semibold tracking-wide transition-all rounded-sm cursor-pointer font-inter ${
                active === i ? "bg-[#00ff88] text-[#080808]" : "text-white/40 hover:text-white"
              }`}
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`${s.icon} text-sm leading-none`} />
              </div>
              {s.title}
            </button>
          ))}
        </div>

        <div key={svc.id} className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="text-[#00ff88] text-xs tracking-[0.3em] uppercase font-semibold mb-4 font-inter">{svc.tagline}</div>
            <h2 className="text-4xl lg:text-5xl font-black text-white tracking-tight mb-6 font-syne">{svc.title}</h2>
            <p className="text-white/50 text-base leading-relaxed mb-8 font-inter">{svc.desc}</p>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-10">
              {svc.features.map((f) => (
                <li key={f} className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                    <i className="ri-checkbox-circle-line text-[#00ff88] text-sm leading-none" />
                  </div>
                  <span className="text-white/60 text-sm font-inter">{f}</span>
                </li>
              ))}
            </ul>
            <div className="flex items-center gap-2 text-[#f59e0b] text-sm font-semibold tracking-widest uppercase cursor-pointer hover:gap-4 transition-all font-inter">
              <span>Start a Project</span>
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-line text-base leading-none" />
              </div>
            </div>
          </div>
          <div className="relative rounded-sm overflow-hidden h-[400px]">
            <img src={svc.image} alt={svc.title} title={svc.title} className="w-full h-full object-cover object-top" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#080808]/60 to-transparent" />
            <div className="absolute bottom-6 left-6 right-6">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#080808]/80 border border-white/10 rounded-sm backdrop-blur-sm">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className={`${svc.icon} text-[#00ff88] text-sm leading-none`} />
                </div>
                <span className="text-white text-sm font-semibold font-syne">{svc.title}</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-[#0a0a0a]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="mb-14">
            <div className="text-[#f59e0b] text-xs tracking-[0.3em] uppercase font-semibold mb-4 font-inter">Full Breakdown</div>
            <h2 className="text-4xl font-black text-white tracking-tight font-syne">Everything We Deliver</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/5 rounded-sm overflow-hidden">
            {services.map((s, i) => (
              <button
                key={s.id}
                onClick={() => { setActive(i); window.scrollTo({ top: 0, behavior: "smooth" }); }}
                className="bg-[#0f0f0f] p-8 text-left group hover:bg-[#141414] transition-colors cursor-pointer relative overflow-hidden"
              >
                <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#00ff88] to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                <div className="w-12 h-12 flex items-center justify-center rounded-sm bg-[#00ff88]/10 border border-[#00ff88]/20 mb-6 group-hover:bg-[#00ff88]/15 transition-all">
                  <i className={`${s.icon} text-[#00ff88] text-xl leading-none`} />
                </div>
                <h3 className="text-white font-bold text-base mb-3 font-syne">{s.title}</h3>
                <p className="text-white/35 text-sm leading-relaxed mb-4 line-clamp-3 font-inter">{s.desc}</p>
                <div className="text-[#00ff88] text-xs tracking-widest uppercase font-semibold flex items-center gap-1.5 opacity-0 group-hover:opacity-100 transition-opacity font-inter">
                  <span>Details</span>
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-xs leading-none" />
                  </div>
                </div>
              </button>
            ))}
          </div>
        </div>
      </section>


    </>
  );
}
